'use client'
import { jsx, jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { useCombobox } from "downshift";
import { AutocompleteListItem } from "./AutocompleteListItem/AutocompleteListItem.js";
import { CdnIcon } from "../CdnIcon/index.js";
import { InputText } from "../InputText/index.js";
import { Span } from "../Text/index.js";
import { cn } from "../../utils/cn.js";
import { ScrollArea } from "../ScrollArea/index.js";
function getIconName(itemLocationType) {
    if ('AIRPORT' === itemLocationType) return 'flight_takeoff';
    if ('POI' === itemLocationType) return 'location_on';
    return 'location_city';
}
const Autocomplete_Autocomplete = function({ autocompleteData, handleInputChange, handleSelectItem, handleOnMenuOpen, initialSelectedItem, name, helperText, iconName = 'search', label = 'Where to?', className, errorMessage, inputRef }) {
    const [items, setItems] = useState([
        ...autocompleteData
    ]);
    const [selectedItem, setSelectedItem] = useState(initialSelectedItem ?? null);
    const [highlightedIndexWithKeyArrow, setHighlightedIndexWithKeyArrow] = useState(-1);
    const wrapperClassName = cn('relative flex flex-col gap-1', className);
    useEffect(()=>{
        setItems([
            ...autocompleteData
        ]);
    }, [
        autocompleteData
    ]);
    const { isOpen, getMenuProps, getInputProps, highlightedIndex, getItemProps } = useCombobox({
        initialSelectedItem: initialSelectedItem ?? null,
        initialInputValue: initialSelectedItem?.itemName ?? '',
        onInputValueChange ({ inputValue }) {
            if ('' === inputValue) setSelectedItem(null);
            handleInputChange(inputValue);
        },
        onSelectedItemChange ({ selectedItem }) {
            if (selectedItem && handleSelectItem) handleSelectItem(selectedItem);
            setSelectedItem(selectedItem);
        },
        onHighlightedIndexChange: (event)=>{
            '__input_keydown_arrow_down__' === event.type || '__input_keydown_arrow_up__' === event.type ? setHighlightedIndexWithKeyArrow(event.highlightedIndex) : setHighlightedIndexWithKeyArrow(-1);
        },
        onIsOpenChange: ()=>{
            if (!isOpen && handleOnMenuOpen) handleOnMenuOpen();
        },
        items,
        itemToString (item) {
            return item ? item.itemName : '';
        }
    });
    const inputProps = getInputProps({
        id: 'base-ui-:r2:',
        ref: inputRef
    });
    return /*#__PURE__*/ jsxs("div", {
        className: wrapperClassName,
        children: [
            /*#__PURE__*/ jsx(InputText, {
                iconLeft: iconName ?? void 0,
                isInset: true,
                label: label,
                "data-testid": "autocomplete-input",
                name: name,
                errorMessage: errorMessage,
                helperText: helperText,
                hasExternalError: Boolean(errorMessage),
                ...inputProps
            }),
            /*#__PURE__*/ jsx("ul", {
                className: `flex flex-col gap-1 shadow-md ${!(isOpen && items.length) && 'hidden'} z-100 bg-neutral-1 absolute top-[52px] h-[300px] w-full rounded-xl`,
                ...getMenuProps(),
                children: /*#__PURE__*/ jsx(ScrollArea, {
                    className: "h-full",
                    children: isOpen && items.length > 0 && items.map((item, index)=>void 0 === item.isGroupHeader ? /*#__PURE__*/ jsx(AutocompleteListItem, {
                            firstLine: item.displayLine1 ?? item.itemName,
                            secondLine: item.displayLine2 ?? void 0,
                            leftNode: item.type && /*#__PURE__*/ jsx(CdnIcon, {
                                palette: "primary",
                                shade: "10",
                                iconName: getIconName(item.type),
                                size: "24"
                            }),
                            isHighlighted: highlightedIndex === index,
                            isHighlightedIndexWithKeyArrow: highlightedIndexWithKeyArrow === index,
                            isSelected: selectedItem?.itemName === item.itemName,
                            ...getItemProps({
                                item,
                                index
                            })
                        }, `${item.itemName}`) : /*#__PURE__*/ jsx("div", {
                            className: "h-8 p-1 pt-3",
                            children: /*#__PURE__*/ jsx(Span, {
                                textStyle: "body3",
                                color: "primary-13",
                                children: item.itemName
                            })
                        }, `${item.itemName}`))
                })
            })
        ]
    });
};
export { Autocomplete_Autocomplete as Autocomplete };
